/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Styles
import classes from './FormWrapper.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const FormWrapper = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<div className={classes.form}>
			<div className={classes.formContent}>
				{children}
			</div>
		</div>
	);
};
